<template> <div id="app"> </div><router-view/></template>